module.exports = __webpack_public_path__ + "static/media/Datas_Arqui_Integracao.ff227c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Datas_Arqui_Integracao.png
// module id = 122
// module chunks = 0